import { ListItemButton } from '@mui/material';
import { styled } from '@mui/system';

import { shouldForwardProp } from '@helpers/misc';

import { NavigationListItemButtonStyledProps } from './types';

export const NavigationListItemButtonStyled = styled(ListItemButton, {
  shouldForwardProp: (prop) =>
    shouldForwardProp<NavigationListItemButtonStyledProps>(['level'], prop),
})<NavigationListItemButtonStyledProps>(({ theme, level }) => ({
  borderRadius: 0,
  marginBottom: theme.spacing(0.5),
  alignItems: 'flex-start',
  py: theme.spacing(level > 1 ? 1 : 1.25),
  pl: `${level * 24}px`,
}));
